<template>
  <!-- 会员管理 -->
  <a-layout-content>
    <div>
      <a-form layout="inline">
        <a-form-item label="会员账号">
          <a-input v-model="userid" />
        </a-form-item>
        <a-form-item label="状态">
          <a-select v-model="status" style="width: 183px">
            <a-select-option value="0"> 全部</a-select-option>
            <a-select-option value="1"> 正常</a-select-option>
            <a-select-option value="2"> 停用</a-select-option>
            <a-select-option value="3"> 注销</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="实名状态">
          <a-select v-model="verified" style="width: 183px">
            <a-select-option value="-1"> 全部</a-select-option>
            <a-select-option value="0"> 未上传</a-select-option>
            <a-select-option value="1"> 认证成功</a-select-option>
            <a-select-option value="2"> 审核中</a-select-option>
            <a-select-option value="3"> 审核失败</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="search()">查询</a-button>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="onEdit(undefined)"
            >添加会员</a-button
          >
        </a-form-item>
        <a-form-item>
          <a-button type="danger" @click="checkDelete()">批量删除</a-button>
        </a-form-item>
        <a-form-item>
          <a-button type="danger" @click="AllDelete()">删除所有</a-button>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" class="marr10" @click="SubmitExport()" >导出</a-button>
        </a-form-item>
        
      </a-form>
    </div>
    <br />
    <a-table
      size="middle"
      :columns="columns"
      row-key="User"
      :data-source="data"
      :pagination="false"
      :loading="loading"
      bordered
      :row-selection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
      }"
    >
      <template slot="status" slot-scope="text">
        <span v-if="text == 1">正常</span>
        <span v-if="text == 2">停用</span>
        <span v-if="text == 3">注销</span>
      </template>
      <template slot="verified" slot-scope="text, record">
        <span class="red" v-if="text == 0">未上传</span>
        <span v-if="text == 1">
          <a class="success" href="javascript:;" @click="onVerified(record)"
            >认证成功
            <a-icon type="file-image" style="font-size: 22px"></a-icon>
          </a>
        </span>
        <span v-if="text == 2">
          <a class="warning" href="javascript:;" @click="onVerified(record)"
            >审核中
            <a-icon type="file-image" style="font-size: 22px"></a-icon>
          </a>
        </span>
        <span v-if="text == 3">
          <a class="warning" href="javascript:;" @click="onVerified(record)"
            >审核失败
            <a-icon type="file-image" style="font-size: 22px"></a-icon>
          </a>
        </span>
        <div style="float:right">
          <a-button v-if="record.VerifiedCount==0" type="dashed" shape="circle" size="small" @click="onVerifiedLog(record)">
            {{record.VerifiedCount}}
          </a-button>
          <a-button v-if="record.VerifiedCount>0" type="danger" shape="circle" size="small" @click="onVerifiedLog(record)">
            {{record.VerifiedCount}}
          </a-button>
        </div>
      </template>
      <template slot="operate" slot-scope="text, record">
        <a-tooltip>
          <template slot="title"> 修改密码 </template>
          <a href="javascript:;" @click="onPwd(record)">
            <a-icon type="user" style="font-size: 22px"></a-icon>
          </a>
        </a-tooltip>
        <span>&nbsp;</span>
        <a-tooltip>
          <template slot="title"> 编辑 </template>
          <a href="javascript:;" @click="onEdit(record)">
            <a-icon type="edit" style="font-size: 22px"></a-icon>
          </a>
        </a-tooltip>
        <span>&nbsp;</span>
        <a-tooltip>
          <template slot="title"> 删除 </template>
          <a-popconfirm title="确定要删除?" @confirm="() => onDelete(record)">
            <a href="javascript:;">
              <a-icon type="delete" style="font-size: 22px"></a-icon>
            </a>
          </a-popconfirm>
        </a-tooltip>
      </template>
    </a-table>
    <div style="margin: 16px 0; height: 8px">
      <a-pagination
        style="float: right"
        show-size-changer
        :default-current="pagination.current"
        :total="pagination.total"
        :show-total="(total) => `共 ${total} 条`"
        :pageSizeOptions="pagination.sizeList"
        @change="pageNumberChange"
        @showSizeChange="sizeChange"
      />
    </div>
    <!-- 对话框 ------------------------------------->
    <a-modal v-model="visible" title="编辑" @ok="modalOk" @cancel="modalCancel">
      <a-form-model
        ref="ruleForm"
        :rules="rules"
        :model="formModel"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item has-feedback label="会员账号" ref="User" prop="User">
          <a-input
            v-model="formModel.User"
            placeholder="会员账号"
            :readOnly="modelUser != 1"
          />
        </a-form-model-item>
        <a-form-model-item
          has-feedback
          label="密码"
          ref="Pwd"
          prop="Pwd"
          v-if="modelUser != 3"
        >
          <a-input-password v-model="formModel.Pwd" @change="clearpwd2" />
        </a-form-model-item>
        <a-form-model-item
          has-feedback
          label="确认密码"
          ref="OkPwd"
          prop="OkPwd"
          v-if="modelUser != 3"
        >
          <a-input-password v-model="formModel.OkPwd" />
        </a-form-model-item>
        <a-form-model-item has-feedback label="实名认证" v-if="modelUser == 3">
          <a-select v-model="formModel.Verified">
            <a-select-option value="0"> 未认证</a-select-option>
            <a-select-option value="1"> 认证成功</a-select-option>
            <a-select-option value="2"> 审核中</a-select-option>
            <a-select-option value="3"> 审核失败</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item has-feedback label="状态" v-if="modelUser != 2">
          <a-select v-model="formModel.Status">
            <a-select-option value="1"> 正常</a-select-option>
            <a-select-option value="2"> 停用</a-select-option>
            <a-select-option value="3"> 注销</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="备注" v-if="modelUser != 2">
          <a-textarea
            v-model="formModel.Memo"
            :auto-size="{ minRows: 3, maxRows: 5 }"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!-- 实名认证 对话框 ------------------------------------->
    <a-modal v-model="isVerified" title="实名认证信息" @ok="verifiedOk">
      <a-form-model
        :model="verifiedModel"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item has-feedback label="持卡人">
          <a-input v-model="verifiedModel.BankcardName" :readOnly="true" />
        </a-form-model-item>
        <a-form-model-item has-feedback label="银行卡">
            <a href="javascript:;" @click="onIamge(verifiedModel.Bankcard)">
          <img
            style="width: 200px; heigth: 100px"
            :src="verifiedModel.Bankcard"
            alt="avatar"
          />
            </a>
        </a-form-model-item>
        <a-form-model-item has-feedback label="身份证正面">
            <a href="javascript:;" @click="onIamge(verifiedModel.IDcardPositive)">
          <img
            style="width: 200px; heigth: 100px"
            :src="verifiedModel.IDcardPositive"
            alt="avatar"
          /></a>
        </a-form-model-item>
        <a-form-model-item has-feedback label="身份证反面">
            <a href="javascript:;" @click="onIamge(verifiedModel.IDcardNegative)">
          <img
            style="width: 200px; heigth: 100px"
            :src="verifiedModel.IDcardNegative"
            alt="avatar"
          /></a>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!-- 实名认证记录 对话框 ------------------------------------->
    <a-modal v-model="isVerifiedLog" title="通知记录" width="850px" @ok="verifiedLogOk">
      <a-form-model
        layout="inline"
      >
        <a-form-model-item has-feedback label="会员账户">
          <a-input v-model="verifiedLogModel.User" :readOnly="true" />
        </a-form-model-item>
      </a-form-model>
    <a-table
      size="middle"
      :columns="verifiedLogColumns"
      row-key="ID"
      :data-source="verifiedLogData"
      :pagination="false"
      :loading="verifiedLogLoading"
      bordered
    >
      <template slot="operate" slot-scope="text, record">
        <a-tooltip>
          <template slot="title"> 删除 </template>
          <a-popconfirm title="确定要删除?" @confirm="() => onverifiedLogDelete(record)">
            <a href="javascript:;">
              <a-icon type="delete" style="font-size: 22px"></a-icon>
            </a>
          </a-popconfirm>
        </a-tooltip>
      </template>
    </a-table>
    <div style="margin: 16px 0; height: 20px">
      <a-pagination
        style="float: right"
        show-size-changer
        :defaultPageSize="5"
        :default-current="verifiedLogPagination.current"
        :total="verifiedLogPagination.total"
        :show-total="(total) => `共 ${total} 条`"
        :pageSizeOptions="verifiedLogPagination.sizeList"
        @change="pageNumberChangeLog"
        @showSizeChange="sizeChangeLog"
      />
    </div>
      <a-form-model
        layout="inline"
      >
        <a-form-model-item has-feedback label="备注">
          <a-textarea
            v-model="verifiedLogModel.Memo"
            :auto-size="{ minRows: 3, maxRows: 5 }"
            style="width: 400px;"
          />
        </a-form-model-item>
        <a-form-model-item has-feedback>
          <a-button type="primary" @click="verifiedLogAdd">发送</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-layout-content>
</template>
<script>
import { isSpecialStr, isNumber } from "../../js/textverify";

export default {
  data() {
    return {
      visible: false, //弹框状态
      formModel: {}, // 弹框字段
      isVerified: false,
      verifiedModel: {},
      modelUser: 0,
      labelCol: { span: 5 },
      wrapperCol: { span: 14 },
      userid: undefined,
      verified: "-1",
      status: "1",
      selectedRowKeys: [],
      data: [],
      columns: [
        {
          title: "ID",
          dataIndex: "ID",
          align: "center",
          width: "150px",
        },
        {
          title: "账户ID",
          dataIndex: "User",
          align: "center",
        },
        {
          title: "实名认证",
          dataIndex: "Verified",
          align: "center",
          scopedSlots: { customRender: "verified" },
        },
        {
          title: "状态",
          dataIndex: "Status",
          align: "center",
          scopedSlots: { customRender: "status" },
        },
        {
          title: "最后登录时间",
          dataIndex: "Lastlogin",
          align: "center",
        },
        {
          title: "最后登录IP",
          dataIndex: "IP",
          align: "center",
        },
        {
          title: "备注",
          dataIndex: "Memo",
          align: "center",
        },
        {
          title: "操作",
          dataIndex: "operate",
          align: "center",
          scopedSlots: { customRender: "operate" },
        },
      ],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        sizeList: ["10", "20", "30", "40", "50"],
      },
      loading: false,
      type: 1,
      rules: {
        User: [
          { required: true, message: "请输入会员账号", trigger: "blur" },
          { min: 1, max: 20, message: "长度应该是1到20", trigger: "blur" },
        ],
        Pwd: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { validator: isSpecialStr, trigger: "change" },
        ],
      },
      isVerifiedLog: false,
      verifiedLogModel: {
        User:"",
        Memo:"",
      },
      verifiedLogColumns:[
        {
          title: "ID",
          dataIndex: "ID",
          align: "center",
        },
        {
          title: "备注",
          dataIndex: "Memo",
          align: "center",
        },
        {
          title: "备注时间",
          dataIndex: "Fdt",
          align: "center",
        },
        {
          title: "操作",
          dataIndex: "operate",
          align: "center",
          scopedSlots: { customRender: "operate" },
        },
      ],
      verifiedLogData: [],
      verifiedLogLoading: false,
      verifiedLogPagination: {
        current: 1,
        pageSize: 5,
        total: 0,
        sizeList: ["5","10","20"]
      },
    };
  },
  methods: {
    //分页页数的改变
    pageNumberChange(current, size) {
      this.pagination.current = current;
      this.pagination.pageSize = size;
      this.qryListAPI();
    },
    //  分页显示条数的变化
    sizeChange(current, size) {
      this.pagination.current = current;
      this.pagination.pageSize = size;
      this.qryListAPI();
    },
    // 搜索
    search() {
      this.pagination.current = 1;
      this.qryListAPI();
    },
    // 编辑
    onEdit(data) {
      this.visible = true;
      this.formModel = {};
      if (data === undefined) {
        //添加
        this.modelUser = 1;
        this.formModel = {Type:1,Status:"1",Verified:"0"}
      } else {
        //编辑
        let Status = "" + data.Status;
        let Verified = "" + data.Verified;
        this.modelUser = 3;
        this.formModel = {Type:3,Status:Status,Verified:Verified,Memo:data.Memo,User:data.User}
      }
    },
    onPwd(data) {
      this.visible = true;
      this.formModel = {};
      this.formModel.User = data.User;
      this.modelUser = 2;
      this.formModel.Type = 2;
    },
    // 编辑确认
    modalOk() {
      // 弹框确认动作
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (
            this.modelUser != 3 &&
            this.formModel.Pwd != this.formModel.OkPwd
          ) {
            this.$message.error("密码与确认密码不一致!");
            return false;
          }

          let url =
            this.formModel.Type === 1
              ? "/AccountTrans/AddAccounttransMember"
              : "/AccountTrans/SaveAccounttransMember";

          this.axios
            .post(url, {
              User: this.formModel.User,
              Status: this.formModel.Status,
              Pwd: this.formModel.Pwd,
              Memo: this.formModel.Memo,
              Type: this.formModel.Type,
              Verified: this.formModel.Verified,
            })
            .then((res) => {
              if (res.data) {
                this.$message.success("编辑成功");
                this.qryListAPI();
                this.visible = false;
              }
            });
        }
      });
    },
    modalCancel() {
      this.$refs["ruleForm"].clearValidate();
    },
    // 删除
    onDelete(data) {
      const idList = [];
      idList.push({ ID: data.User });
      this.axios
        .post("/AccountTrans/DeleteAccounttransMember", {
          UserList: idList,
          Type: 0,
        })
        .then((res) => {
          if (res.data) {
            this.$message.success("删除成功");
            this.qryListAPI();
          }
        });
    },
    // 删除所有
    AllDelete() {
      const that = this;
      this.$confirm({
        title: "批量删除",
        content: "您要确定要删除所有吗?",
        onOk() {
          that.axios
            .post("/AccountTrans/DeleteAccounttransMember", {
              UserList: [],
              Type: 1,
            })
            .then((res) => {
              if (res.data) {
                that.$message.success("删除成功");
                that.qryListAPI();
              }
            });
        },
      });
    },
    // 查询API
    qryListAPI() {
      this.loading = true;
      let params = {
        User: this.userid == undefined ? "" : this.userid,
        Status: this.status,
        Verified: this.verified,
        pageindex: this.pagination.current,
        pagesize: this.pagination.pageSize,
      };

      this.axios
        .post("/AccountTrans/GetAccounttransMemberList", params)
        .then((res) => {
          if (res.data) {
            this.pagination.total = res.total;
            this.loading = false;
            this.data = res.data;
          }
        });
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    // 勾选删除
    checkDelete() {
      if (this.selectedRowKeys.length < 1) {
        this.$message.warning("请勾选数据");
        return;
      }
      const that = this;
      this.$confirm({
        title: "批量删除",
        content: "您要确定要删除勾选数据吗?",
        onOk() {
          const idList = [];
          that.selectedRowKeys.forEach((element) => {
            idList.push({ ID: element });
          });
          that.axios
            .post("/AccountTrans/DeleteAccounttransMember", {
              UserList: idList,
              Type: 0,
            })
            .then((res) => {
              if (res.data) {
                that.$message.success("删除成功");
                that.qryListAPI();
              }
            });
        },
      });
    },
    clearpwd2() {
      this.formModel.OkPwd = "";
    },
    onVerified(data) {
      const that = this;
      this.axios
        .post("/AccountTrans/GetAccounttransVerifiedById", {User:data.User})
        .then((res) => {
          if (res.data) {
            that.verifiedModel.Bankcard= res.data[0].Bankcard;
            that.verifiedModel.BankcardName= res.data[0].BankcardName;
            that.verifiedModel.IDcardPositive= res.data[0].IDcardPositive;
            that.verifiedModel.IDcardNegative= res.data[0].IDcardNegative;
            that.isVerified = true;
          }
        });
    },
    verifiedOk() {
      this.isVerified = false;
    },
    verifiedLogOk() {
      this.isVerifiedLog = false;
    },
    //分页页数的改变
    pageNumberChangeLog(current, size) {
      this.verifiedLogPagination.current = current;
      this.verifiedLogPagination.pageSize = size;
      this.qryVerifiedClientLog();
    },
    //  分页显示条数的变化
    sizeChangeLog(current, size) {
      this.verifiedLogPagination.current = current;
      this.verifiedLogPagination.pageSize = size;
      this.qryVerifiedClientLog();
    },
    //备注消息动作
    onVerifiedLog(data){
      this.verifiedLogModel.User = data.User;
      this.isVerifiedLog = true;
      this.qryVerifiedClientLog();
    },
    //备注消息查询
    qryVerifiedClientLog(){
      let params = {
        SaleUser: this.verifiedLogModel.User,
        Type: 1,
        pageindex: this.verifiedLogPagination.current,
        pagesize: this.verifiedLogPagination.pageSize,
      };

      this.axios
        .post("/AccountTrans/getaccounttransverifiedclientloglist", params)
        .then((res) => {
          if (res.data) {
            this.verifiedLogPagination.total = res.total;
            this.verifiedLogLoading = false;
            this.verifiedLogData = res.data;
          }
        });
    },
    //备注消息删除
    onverifiedLogDelete(data){
      this.axios
        .post("/AccountTrans/accounttransverifiedclientlogdelete", {
          ID: data.ID,
        })
        .then((res) => {
          if (res.data) {
            this.$message.success("删除成功");
            this.qryVerifiedClientLog();
          }
        });
    },
    //备注消息发送
    verifiedLogAdd(){
      if(this.verifiedLogModel.Memo == ""){
        this.$message.warning("备注信息不可为空!");
        return;
      }

      let params = {
        UserID: this.verifiedLogModel.User,
        Memo: this.verifiedLogModel.Memo,
      };
      this.axios
        .post("/AccountTrans/accounttransverifiedclientlogAdd", params)
        .then((res) => {
          if (res.data) {
            this.$message.success("发送成功");
            this.verifiedLogModel.Memo = "";
            this.qryVerifiedClientLog();
          }
        });
    },
    // 查看交易截图
    onIamge(data){
        window.open(data);
    },
    // 提交导出
    SubmitExport() {
      const that = this;
      this.$confirm({
        title: "导出",
        content: "确定要导出数据吗？",
        onOk() {
          that.exportData();
        },
      });
    },
    //导出
    exportData() {
      let today = new Date();

      this.$message.success("开始执行导出请在停留在页面勿离开,因数据量较多请稍待片刻谢谢");
      this.axios({
        url: "/AccountTrans/exportaccounttransmemberlist",
        method: "get",
        params: {
          UserID: this.userid == undefined ? "" : this.userid,
          Status: this.status,
          Verified: this.verified,
        },
        responseType: "blob",
      }).then((response) => {
        let blob = new Blob([response.data], { type: response.data.type });
        // 针对于 IE 浏览器的处理, 因部分 IE 浏览器不支持 createObjectURL
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob);
        } else {
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(blob); // 创建下载的链接
          downloadElement.href = href;
          downloadElement.download = "会员帐号导出- "+today.toISOString().split('T')[0]; // 下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); // 点击下载
          document.body.removeChild(downloadElement); // 下载完成移除元素
          window.URL.revokeObjectURL(href); // 释放掉 blob 对象
        }
      });
    },
  },
  watch: {
    $route(to, from) {
      if (this.$route.params.name === "user") {
        this.userid = this.$route.params.userid;
        this.qryListAPI();
      }
    },
  },
  //首次加载
  created() {
    if (this.$route.params.name === "user") {
      this.userid = this.$route.params.userid;
    }
    this.qryListAPI();
    const array = JSON.parse(sessionStorage.RoleID);
    // const roleID = [55,56,57,80,81];
    // var isRole = roleID.filter(function(item){
    //   return array.indexOf(item) != -1
    // });
    // //功能权限获取
    // isRole.forEach(element => {
    //   this["role" + element] = true;
    // });
  },
};
</script>

<style>
.red {
  color: #ff7875;
}
.success {
  color: #67bd25;
}
.warning {
  color: #ff9800;
}
.marr10 {
  margin-right: 10px;
  background-color: green;
}
</style>



// WEBPACK FOOTER //
// src/components/accounttransaction/accountuser.vue